<template>
  <div class="about">
    <div id="about" class="anchor"></div>
    <p>用户第一 坚持创新 诚信正直 乐观坚韧</p>
    <lr-link :to="url" @click="reportClick()"><div class="about-button">联系我们</div></lr-link>
  </div>
</template>
<script>
export default {
  data() {
    return {
      url: 'https://f.wps.cn/w/3USpGCD5/?chan=pc_company_made',
    };
  },
  methods: {
    reportClick() {
      this.$collect.enterpriseHomepageClick({
        click: 'contact',
        area: 'about',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.about {
  margin-top: 90px;
  width: 100%;
  height: 302px;
  background-color: #fafbfd;
  text-align: center;
  padding: 80px 0 0;

  > p {
    height: 56px;
    font-size: 40px;
    font-weight: 600;
    color: #222226;
    line-height: 56px;
    margin-bottom: 30px;
  }
  &-button {
    width: 187px;
    height: 56px;
    background: #417ff9;
    border-radius: 28px;
    border: 1px solid #417ff9;
    line-height: 56px;
    text-align: center;
    color: #ffffff;
    font-size: 20px;
    font-weight: 500;
    display: inline-block;

    &:hover {
      cursor: pointer;
      border: 1px solid #417ff9;
      background-color: #417ff9;
      color: #ffffff;
      opacity: 0.7;
    }
  }
}
</style>
